<template>
    <el-row class="content_main houseresource">
        <div style="height:90px;">
            <el-row>
                <Personal ref="mychild"></Personal>
            </el-row>
        </div>
        <el-tabs style='width:1100px' v-model="activeName" @tab-click="handleClick"  v-loading="loading">
            <el-tab-pane label="未发布" name="first" class="status_menu">
                <!-- <el-row> -->
                    <el-col :span="8">
                        <el-card :body-style="{ padding: '0px' }"> 
                            <img class="image" src="../../../images/addpic_bg.png" alt="">
                            <img style="position:absolute;top:50px;left:130px;" src="../../../images/addpic.png" alt="">
                            <el-row class="property_infor">
                                <el-row class="property_title property_infor_item" style="background:#efefef;width:300px;height:20px;"></el-row>
                                <el-row class="property_update property_infor_item" style="background:#efefef;width:160px;height:20px;"></el-row>
                                <el-row class="property_status property_infor_item" style="background:#efefef;width:260px;height:20px;"></el-row>
                            </el-row>
                            <el-button class="addhouseBtn" type="primary" @click="goaddhouse">添加新房源</el-button>
                        </el-card>
                    </el-col> 
                    <el-col :span="8" v-for="(items,index) in dataList" :key="index">
                        <el-card :body-style="{ padding: '0px' }"> 
                            <img class="image" :src="items.pictureUrl?'http://crm.joannarealestate.com.cn' + items.pictureUrl:'../../../images/addpic_bg.png'" alt="">
                            <div class="houseresource_rent">
                                <span style="font-size:16px;display:inline-block">￥{{items.MAX_ZJ}}</span>/月
                            </div>
                            <el-row class="property_infor">
                                <el-row class="property_title property_infor_item"><p style="font-size:18px;font-weight: 700;">{{items.C_COMName}}</p></el-row>
                                <el-row class="property_update property_infor_item" style="font-size:14px"><p>{{items.UpdateTime}}<span  @click="look(items)" style="color:#399DFA;cursor: pointer;">&nbsp;更新</span></p></el-row>
                                <el-row class="property_status property_infor_item" >未发布原因:<span @click="wfbReason(items)" style="color:#399DFA;cursor: pointer;padding-left:10px;">{{items.Reason}}</span></el-row>
                            </el-row>
                            <div class="clearfix">
                                <el-button class="lookthrough" type="primary" @click="look(items)">浏览</el-button>
                            </div>
                            <el-row class="operate_btn">
                                <el-button class="ptoperty_edit" type="text" @click="look(items)">编辑</el-button>
                                <el-button type="text" v-on:click="deleteproperty(items)">删除</el-button>
                                <el-button class="ptoperty_apply_audit" type="text" @click="applyAudit(items)">申请审核</el-button>
                            </el-row>
                        </el-card>
                    </el-col> 
            </el-tab-pane>
            <el-tab-pane label="审核中" name="second" class="status_menu">
                <el-col :span="8" v-if='dataList.length < 1'>
                    <el-card :body-style="{ padding: '0px' }"> 
                        <img class="image" src="../../../images/addpic_bg.png" alt="">
                        <img style="position:absolute;top:50px;left:130px;" src="../../../images/addpic.png" alt="">
                        <el-row class="property_infor">
                            <el-row class="property_title property_infor_item" style="background:#efefef;width:300px;height:20px;"></el-row>
                            <el-row class="property_update property_infor_item" style="background:#efefef;width:160px;height:20px;"></el-row>
                            <el-row class="property_status property_infor_item" style="background:#efefef;width:260px;height:20px;"></el-row>
                        </el-row>
                        <el-button class="addhouseBtn" type="primary"  @click="goaddhouse">添加新房源</el-button>
                    </el-card>
                </el-col> 
                <el-col :span="8" v-for="(items,index) in dataList" :key="index">
                    <el-card :body-style="{ padding: '0px' }"> 
                        <img class="image" :src="items.pictureUrl?'http://crm.joannarealestate.com.cn' + items.pictureUrl:'../../images/addpic_bg.png'" alt="">
                        <div class="houseresource_rent">
                            <span style="font-size:16px;display:inline-block">￥{{items.MAX_ZJ}}</span>/月
                        </div>
                        <el-row class="property_infor">
                            <el-row class="property_title property_infor_item"><p style="font-size:18px;font-weight: 700;">{{items.C_COMName}}</p></el-row>
                            <el-row class="property_update property_infor_item" style="font-size:14px"><p>{{items.UpdateTime}}<span style="color:#399DFA;cursor: pointer;">&nbsp;更新</span></p></el-row>
                            <el-row class="property_status property_infor_item">出租提醒：完善更多房源信息利于出租</el-row>
                        </el-row>
                        <div class="clearfix">
                            <el-button class="lookthrough" type="primary">浏览</el-button>
                        </div>
                        <el-row class="operate_btn">
                            <el-button class="ptoperty_cancel_audit" type="text" @click="cancelAudit(items)">撤销审核</el-button>
                            <el-button class="ptoperty_rent" type="text" @click="propertyrental(items)">已出租</el-button>
                        </el-row>
                    </el-card>
                </el-col> 
            </el-tab-pane>
            <el-tab-pane label="已上线" name="third" class="status_menu">
                <!-- <el-row> -->
                    <el-col :span="8" v-if='dataList.length < 1'>
                        <el-card :body-style="{ padding: '0px' }"> 
                            <img class="image" src="../../../images/addpic_bg.png" alt="">
                            <img style="position:absolute;top:50px;left:130px;" src="../../../images/addpic.png" alt="">
                            <el-row class="property_infor">
                                <el-row class="property_title property_infor_item" style="background:#efefef;width:300px;height:20px;"></el-row>
                                <el-row class="property_update property_infor_item" style="background:#efefef;width:160px;height:20px;"></el-row>
                                <el-row class="property_status property_infor_item" style="background:#efefef;width:260px;height:20px;"></el-row>
                            </el-row>
                            <el-button class="addhouseBtn" type="primary"  @click="goaddhouse">添加新房源</el-button>
                        </el-card>
                    </el-col> 

                    <el-col :span="8" v-for="(items,index) in dataList" :key="index">
                        <el-card :body-style="{ padding: '0px' }"> 
                            <img class="image" :src="items.pictureUrl?'http://crm.joannarealestate.com.cn' + items.pictureUrl:'../../images/addpic_bg.png'" alt="">
                            <div class="houseresource_rent">
                                <span style="font-size:16px;display:inline-block">￥{{items.MAX_ZJ}}</span>/月
                            </div>
                            <el-row class="property_infor">
                                <el-row class="property_title property_infor_item"><p style="font-size:18px;font-weight: 700;">{{items.C_COMName}}</p></el-row>
                                <el-row class="property_update property_infor_item" style="font-size:14px"><p>{{items.UpdateTime}}<span style="color:#399DFA;cursor: pointer;">&nbsp;更新</span></p></el-row>
                                <el-row class="property_status property_infor_item">出租提醒：完善更多房源信息利于出租</el-row>
                            </el-row>
                            <div class="clearfix">
                                <el-button class="lookthrough" type="primary">浏览</el-button>
                            </div>
                            <el-row class="operate_btn">
                                <el-button class="ptoperty_offline" type="text">房源下线</el-button>
                                <el-button class="ptoperty_rent" type="text" @click="propertyrental(items)">已出租</el-button>
                            </el-row>
                        </el-card>
                    </el-col> 
                
            </el-tab-pane>
            <el-tab-pane label="出租中" name="fourth" class="status_menu">
                <!-- <el-row> -->

                    <el-col :span="8" v-if='dataList.length < 1'>
                        <el-card :body-style="{ padding: '0px' }"> 
                            <img class="image" src="../../../images/addpic_bg.png" alt="">
                            <img style="position:absolute;top:50px;left:130px;" src="../../../images/addpic.png" alt="">
                            <el-row class="property_infor">
                                <el-row class="property_title property_infor_item" style="background:#efefef;width:300px;height:20px;"></el-row>
                                <el-row class="property_update property_infor_item" style="background:#efefef;width:160px;height:20px;"></el-row>
                                <el-row class="property_status property_infor_item" style="background:#efefef;width:260px;height:20px;"></el-row>
                            </el-row>
                            <el-button class="addhouseBtn" type="primary"  @click="goaddhouse">添加新房源</el-button>
                        </el-card>
                    </el-col> 
                    <el-col :span="8" v-for="(items,index) in dataList" :key="index">
                        <el-card :body-style="{ padding: '0px' }"> 
                            <img class="image" :src="items.pictureUrl?'http://crm.joannarealestate.com.cn' + items.pictureUrl:'../../images/addpic_bg.png'" alt="">
                            <div class="houseresource_rent">
                                <span style="font-size:16px;display:inline-block">￥{{items.MAX_ZJ}}</span>/月
                            </div>
                            <el-row class="property_infor">
                                <el-row class="property_title property_infor_item"><p style="font-size:18px;font-weight: 700;">{{items.C_COMName}}</p></el-row>
                                <el-row class="property_update property_infor_item" style="font-size:14px"><p>{{items.UpdateTime}}<span style="color:#399DFA;cursor: pointer;">&nbsp;更新</span></p></el-row>
                                <el-row class="property_status property_infor_item">出租提醒：完善更多房源信息利于出租</el-row>
                            </el-row>
                            <div class="clearfix">
                                <el-button class="lookthrough" type="primary" disabled>浏览</el-button>
                            </div>
                            <el-row class="operate_btn">
                                <el-button class="ptoperty_apply_goline" type="text" @click="applyGoline(items)">申请重新上线</el-button>
                            </el-row>
                        </el-card>
                    </el-col> 
                    
            </el-tab-pane>
        </el-tabs>
    </el-row>
</template>

<script>
import Personal from '@/components/personal/personal.vue'
export default {
    components:{
        Personal
    },
    data(){
        return {
            activeName: 'first',
            dataList :[],
            loading:false,
            houseCount: 0
        }
    },
    methods:{
        handleClick(tab, event) {
            if(tab.paneName == 'first'){
                this.getNotRes('WFB');
            }else if(tab.paneName == 'second'){
                this.getNotRes('SHZ');
            }else if(tab.paneName == 'third'){
                this.getNotRes('YSX');
            }else if(tab.paneName == 'fourth'){
                this.getNotRes('YCZ');
            }
        },
        deleteproperty (items) {
            this.$confirm('此操作将永久删除该房源, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$get('/Handler/FYGL.ashx',{Action:'Delete',House_ID:items.ID},data => {
                  this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getNotRes('WFB');//重新刷新
                    this.$refs.mychild.getOwnerHouseCount()
              },error => {

              });
              
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
        
        wfbReason(items){
            //未发布原因
            
            let reason = '';
            if(items.Reason == '未申请审核'){
                reason = '您还没有申请审核该房源'
            }else if(items.Reason == '审核未通过'){
                reason = '请完善信息后重新申请'
            }else if(items.Reason == '投诉下线'){
                reason = '该房源累计被投诉5次导致下线'
            }else if(items.Reason == '系统下线'){
                reason = '该房源超过三个月未更新导致下线'
            }
            this.$alert(reason, items.Reason, {
                confirmButtonText: '我知道了'
            });
            // this.$confirm(reason, items.Reason, {
            //     confirmButtonText: '我知道了',
            //     cancelButtonText: '',
            //     type: 'warning'
            // }).then(() => {
            //     // this.look(items)
            // }).catch(() => {
                 
                      
            // });
        },
        applyAudit(items){
            /*申请审核*/
            this.$confirm('确定要申请审核该房源吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                this.$get('/Handler/FYGL.ashx',{action:'UpdateFYState1',House_ID:items.ID,oper:'applytocheck'},data => {
                    this.$message({
                        type: 'success',
                        message: '已提交申请!'
                    });
                    this.getNotRes('WFB');//重新刷新
                },error => {

                }); 
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消申请'
              });          
            });
        },
        cancelAudit(items){
            //撤销审核
            this.$confirm('确定要撤销审核吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                this.$get('/Handler/FYGL.ashx',{action:'UpdateFYState1',House_ID:items.ID,oper:'canclecheck'},data => {
                    this.$message({
                        type: 'success',
                        message: '已撤销审核!'
                    });
                    this.getNotRes('SHZ');//重新刷新
                },error => {

                });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消申请'
              });          
            });
        },
        propertyrental(items){
            //已出租
            this.$confirm('确定该房源已经出租吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                this.$get('/Handler/FYGL.ashx',{action:'UpdateFYState1',House_ID:items.ID,oper:'rented'},data => {
                    this.$message({
                        type: 'success',
                        message: '该房源已出租!'
                    });
                    this.getNotRes('YSX');//重新刷新
                },error => {

                });
            }).catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消申请'
              // });          
            });
        },
        applyGoline(items){
            //下线
            this.$confirm('确定要重新上线该房源吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                this.$get('/Handler/FYGL.ashx',{action:'UpdateFYState1',House_ID:items.ID,oper:'offline'},data => {
                    this.$message({
                        type: 'success',
                        message: '请在未发布中查看该房源!'
                    });
                    this.getNotRes('YCZ');//重新刷新
                },error => {

                });
              
            }).catch(() => {
              // this.$message({
              //   type: 'info',
              //   message: '已取消'
              // });          
            });
        },
        getNotRes(type){
            this.loading = true;
            let params = {
                Action: 'InitFY1',
                type:type,
                isAll:'1'
            }
            this.$get('/Handler/FYGL.ashx',params,data => {
                this.loading = false;
                this.dataList = data;
                
            },error => {
                this.loading = false;
            });
        },
        look(items){
            this.$router.push({path:'/houseResource/houseResourceEdit',query:{id:items.ID}});
        },
        goaddhouse(){
            this.$router.push({path:'/publishHouse'});
        }
    },
    created(){
        this.getNotRes('WFB');
    }
}
</script>

<style scoped>
    .houseresource{
        padding: 25px;
    }
    .houseresource .property_demo{
        width: 320px;
        height: 350px;
        border: 1px solid #efefef;
        overflow: hidden;
        display: inline-block;
        margin-right: 20px;
    }
    .houseresource .image{
        width: 100%;
        height: 180px;
    }
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    
    .clearfix:after {
        clear: both
    }
    .houseresource .property_infor{
        padding: 10px;
    }
   .houseresource .property_infor .property_infor_item{
        margin-bottom: 5px;
        font-size: 14px;
    }
    .houseresource .addhouseBtn{
        margin: 0 auto;
        display: block;
    }
   .houseresource .lookthrough{
        background-color: #fff;
        border-color: #eee;
        color: #000;
        line-height: 0.3;
        float: right;
        margin-right: 6px;
    }
   .houseresource .operate_btn{
        text-align: right;
        padding-right: 15px;
        margin-bottom: 20px;;
    }
    .el-card{
        margin-right: 20px;
        height: 353px;
        margin-bottom: 20px;
    }
    .houseresource_rent{
        width:140px;
        height: 40px;
        background:rgba(50, 44, 39, 0.7);
        position: absolute;
        top:110px;
        color:#fff;
        line-height: 40px;
        padding-left:10px; 
    }
</style>



// WEBPACK FOOTER //
// src/pages/houseResource/components/houseResourceMessage.vue